import { useRef, useState } from 'react';
import styles from './FormScreen.module.css';
import PrivacyPolicy from '../privacy/Privacy';

const FormScreen = (props) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [agreed, setAgreed] = useState(false);
  const nameRef = useRef('');
  const phoneRef = useRef('');
  const emailRef = useRef('');
  const serverUrl = "https://dynamic-server-dfc88e1f1c54.herokuapp.com/leads/newLead";
  const reciver = "salesns1301@gmail.com";

  // פונקציה שמונעת מהטופס להגיב על קליק בקישור
  const handlePrivacyClick = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  const submitHandler = async (e) => {
    e.preventDefault();

    // בדיקה אם המשתמש אישר את תנאי השימוש ומדיניות הפרטיות
    if (!agreed) {
      alert("עליך לאשר את תנאי השימוש ומדיניות הפרטיות");
      return;
    }

    const name = nameRef?.current?.value;
    const phone = phoneRef?.current?.value;
    const email = emailRef?.current?.value;
    if (name.trim().length <= 2) {
      alert("אנא הכניסי שם מלא ");
      return;
    }
    if (phone.trim().length !== 10) {
      alert("אנא הכניסי מספר טלפון הכולל 10 ספרות ");
      return;
    }
    if (!email.includes("@")) {
      alert("אנא הכניסי מייל תקין ");
      return;
    }

    const serverData = {
      name,
      phone,
      email,
      reciver
    };

    console.log("🔄 שלב 2: הכנה לשליחה");
    console.log("📤 serverData:", serverData);

    setIsSubmitting(true);

    try {
      const serverResponse = await fetch(serverUrl, {
        method: "POST",
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(serverData)
      });

      console.log("✅ שלב 3: התקבלה תגובה מהשרת");
      console.log("🖥️ server response status:", serverResponse.status);

      const serverText = await serverResponse.text();
      console.log("🖥️ server response text:", serverText);

      if (serverResponse.ok) {
        setIsSubmitting(false);
        setSubmitted(true);
        
        // Reset form after 2 seconds
        setTimeout(() => {
          nameRef.current.value = "";
          phoneRef.current.value = "";
          emailRef.current.value = "";
          setSubmitted(false);
          setAgreed(false);
        }, 2000);
      } else {
        throw new Error("שליחה נכשלה");
      }
    } catch (error) {
      console.error("❌ שגיאה:", error);
      alert("התרחשה שגיאה, אנא נסי שוב מאוחר יותר");
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <div className={styles.title} id="טופס">{props.title}</div>
      <div className={styles.formContainer}>
        <form className={styles.form} onSubmit={submitHandler}>
          <input
            type="text"
            className={styles.input}
            placeholder="שם מלא"
            ref={nameRef}
            disabled={isSubmitting || submitted}
          />
          <input
            type="tel"
            className={styles.input}
            placeholder="מספר טלפון"
            ref={phoneRef}
            disabled={isSubmitting || submitted}
          />
          <input
            type="email"
            className={styles.input}
            placeholder="מייל"
            ref={emailRef}
            disabled={isSubmitting || submitted}
          />
          {/* תיבת האישור למדיניות הפרטיות */}
          <div style={{ 
            display: "flex", 
            justifyContent: "center", 
            marginTop: "20px",
            marginBottom: "20px"
          }}>
            <label style={{ 
              direction: "rtl", 
              fontFamily: "AssistantR", 
              fontSize: "0.9rem", 
              textAlign: "right", 
              display: "flex", 
              alignItems: "center", 
              flexWrap: "wrap", 
              gap: "5px" 
            }}>
              <input
                type="checkbox"
                checked={agreed}
                onChange={() => setAgreed(!agreed)}
                style={{ marginLeft: "10px" }}
              />
              קראתי את
              <span onClick={handlePrivacyClick}>
                     <PrivacyPolicy 
  ownerName="נתי ונטורה" 
  email="Natish1301@gmail.com" 
  phone="+972 54-728-9417" 
  domain="https://nati-beauty-academy.co.il/" 
/>
              </span>
              ואני מאשר/ת
            </label>
          </div>

          <button 
            type="submit" 
            className={`${styles.button} ${isSubmitting ? styles.submitting : ''} ${submitted ? styles.submitted : ''}`}
            disabled={isSubmitting || submitted}
          >
            {isSubmitting ? 'טוען...' : submitted ? 'נשלח' : 'נתי, צרי איתי קשר'}
          </button>
        </form>
      </div>
    </>
  );
};

export default FormScreen;